var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0483 12.122L9.54829 23.372C9.41257 23.5174 9.22464 23.6029 9.02585 23.6098C8.82705 23.6166 8.63368 23.5442 8.48826 23.4085C8.29823 23.2312 8.21359 22.968 8.26456 22.7131L9.63949 15.8385L4.23666 13.8125C4.05041 13.7426 3.89954 13.6017 3.81723 13.4206C3.73491 13.2395 3.72791 13.0331 3.79775 12.8469C3.83229 12.7548 3.8846 12.6704 3.95171 12.5985L14.4517 1.34849C14.7343 1.04568 15.2089 1.02932 15.5117 1.31194C15.7018 1.48931 15.7864 1.75242 15.7354 2.00732L14.3605 8.88193L19.7633 10.908C19.9496 10.9778 20.1005 11.1188 20.1828 11.2999C20.2651 11.481 20.2721 11.6873 20.2022 11.8736C20.1677 11.9657 20.1154 12.0501 20.0483 12.122ZM10.2532 20.4183L18.1863 11.9186L13.2367 10.0625C12.8924 9.93337 12.6925 9.5737 12.7646 9.21315L13.7468 4.30219L5.81371 12.8019L10.7633 14.658C11.1076 14.7871 11.3075 15.1468 11.2354 15.5073L10.2532 20.4183Z",
    fill: "#828282"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightningIcon);
export default __webpack_public_path__ + "static/media/LightningIcon.0e3678d34e9dd347b4b6c087365a76f2.svg";
export { ForwardRef as ReactComponent };